import React, { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import Swiper from 'swiper';
import { SwiperSlide } from 'swiper/react';

import { ChevronIcon } from '@icons';
import gtmTracker from '@utils/gtmTracker';

import { useModals } from '@shared/contexts';

import BannerImg from '@assets/images/skinplace/banner.webp';
import Icon1 from '@assets/images/skinplace/img1.webp';
import Icon2 from '@assets/images/skinplace/img2.webp';
import Icon3 from '@assets/images/skinplace/img3.webp';
import Icon4 from '@assets/images/skinplace/img4.webp';

import { useQueryGetMe } from '@hooks/api/user/use-query-me';
import useEnglishTranslation from '@hooks/use-english-translation';

import { Button } from '@components/button';
import { ModalName } from '@components/modals';
import { Slider } from '@components/slider';

import { FaqCase } from './components/faq-case';
import { StepCard } from './components/step-card';
import * as Styled from './skinplace.styles';

import 'swiper/css';

const Skinplace = () => {
	const { openModal } = useModals();
	const { t } = useTranslation('skinplace');
	const tEn = useEnglishTranslation('skinplace');
	const { data: userData } = useQueryGetMe();
	const swiperRef = React.useRef<Swiper>();

	const handleNext = useCallback(() => {
		if (!swiperRef.current) return;
		swiperRef.current.slideNext();
	}, []);

	const handleButton = () => {
		gtmTracker.trackEvent('click', {
			event_category: 'Skinplace',
			event_action: 'click',
			event_label: tEn('exchange_title')
		});
		if (userData?.pm_id) {
			window.open(userData.skin_place_payform_url);
		} else {
			openModal(ModalName.LOGIN);
		}
	};

	return (
		<Styled.Wrapper>
			<Styled.Banner>
				<Styled.BannerContent>
					<Styled.BannerTitle
						dangerouslySetInnerHTML={{
							__html: t('main_title')
						}}
					/>
					<Styled.BannerDescription>{t('main_description')}</Styled.BannerDescription>
					<Styled.ButtonWrapper>
						<Button onClick={handleButton} color='primary' size='large'>
							{t('exchange_title')}
						</Button>
					</Styled.ButtonWrapper>
				</Styled.BannerContent>
				<Styled.BannerImg>
					<img src={BannerImg} alt='banner_image' />
				</Styled.BannerImg>
			</Styled.Banner>
			<Styled.Instruction>
				<Styled.InstructionTitle>{t('instruction')}</Styled.InstructionTitle>
				<Styled.InstructionDescription
					dangerouslySetInnerHTML={{
						__html: t('enrollment')
					}}
				/>
				<Styled.InstructionRate>{t('course')}</Styled.InstructionRate>
				<Styled.InstructionStepsWrapper>
					<Slider
						onBeforeInit={(swiper: any) => {
							swiperRef.current = swiper;
						}}
						id='instruction'
						breakpoints={{
							1100: {
								slidesPerView: 4
							},
							600: {
								slidesPerView: 2.3
							},
							300: {
								slidesPerView: 1.1
							}
						}}
						spaceBetween='16px'
						pagination={false}
						navigation={false}
						loop
					>
						<SwiperSlide virtualIndex={0}>
							<StepCard icon={Icon1} step={t('mission_first_title')} text={t('mission_first_description')} />
						</SwiperSlide>
						<SwiperSlide virtualIndex={1}>
							<StepCard icon={Icon2} step={t('mission_second_title')} text={t('mission_second_description')} />
						</SwiperSlide>
						<SwiperSlide virtualIndex={2}>
							<StepCard icon={Icon3} step={t('mission_third_title')} text={t('mission_third_description')} />
						</SwiperSlide>
						<SwiperSlide virtualIndex={3}>
							<StepCard icon={Icon4} step={t('mission_fourth_title')} text={t('mission_fourth_description')} />
						</SwiperSlide>
					</Slider>
					<Styled.NextBtn onClick={handleNext}>
						<ChevronIcon />
					</Styled.NextBtn>
				</Styled.InstructionStepsWrapper>
			</Styled.Instruction>
			<Styled.Faq>
				<Styled.FaqTitle>{t('faq')}</Styled.FaqTitle>
				{/* <FaqCase main={t('faq_question_1')} sub={t('faq_answer_1')} />
				<Styled.FaqDivider /> */}
				<FaqCase main={t('faq_question_2')} sub={t('faq_answer_2')} />
				<Styled.FaqDivider />
				<FaqCase main={t('faq_question_3')} sub={t('faq_answer_3')} />
				<Styled.FaqDivider />
				<FaqCase main={t('faq_question_4')} sub={t('faq_answer_4')} />
				<Styled.FaqDivider />
				<FaqCase main={t('faq_question_5')} sub={t('faq_answer_5')} />
			</Styled.Faq>
		</Styled.Wrapper>
	);
};

export default Skinplace;
